import { SkeletonText } from '@dev-spendesk/grapes';

import { QueryError } from 'src/core/common/components/QueryError';
import { QuerySuspense } from 'src/core/common/components/QuerySuspense';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useTeamsQuery } from 'src/core/modules/budgets/apis';

import { CommonSelect, type Option } from './CommonSelect';

export const TeamSelect = ({
  selectedValues,
  onSelect,
  mode,
}: {
  selectedValues: { id: string; name: string }[] | undefined | null;
  onSelect: (values: { id: string; name: string }[] | null) => void;
  mode: 'create' | 'edit';
}) => {
  const teamsQueryState = useTeamsQuery();
  const { t } = useTranslation('global');

  const baseOptions: Option[] =
    teamsQueryState.status === 'success'
      ? teamsQueryState.data.map((team) => ({
          key: team.id,
          label: team.name,
        }))
      : [];

  return (
    <QuerySuspense
      queryState={teamsQueryState}
      loading={<SkeletonText size="xxl" />}
      fallback={(error) => (
        <QueryError queryError={error} componentType="Callout" />
      )}
    >
      {() => (
        <CommonSelect
          selectedValues={selectedValues}
          onSelect={onSelect}
          baseOptions={baseOptions}
          placeholder={t('approvalWorkflows.dimensions.team.selectATeam')}
          dimensionName="team"
          mode={mode}
        />
      )}
    </QuerySuspense>
  );
};
